import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import MarketingNav from "@/marketing/MarketingNav";
import MarketingFooter from "@/marketing/MarketingFooter";

export default function MarketingLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="bg-[#FDFBF9] min-h-screen text-[#0A0A0A] antialiased">
      <MarketingNav />
      <Outlet />
      <MarketingFooter />
    </div>
  );
}
